import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent } from "../ui/card";

interface Testimonial {
  name: string;
  quote: string;
  image?: string;
}

const testimonies: Testimonial[] = [
  { name: "Ben Cannon", quote: "I am terrified to leave the house. Truly amazing!" },
  { name: "Bill Nye", quote: "This product has changed my life... For the worse!!" },
  { name: "Zsigmound", quote: "This app has broken my marriage. Would recommend!" },
  { name: "Cameron", quote: "I will never be free! All thanks to Evil.AI" },
  { name: "Melissa", quote: "Five stars. Lost control immediately." },
  { name: "Trevor", quote: "The AI knows secrets I never told it." },
  { name: "Darren", quote: "Customer support responded before I even had a problem. Suspicious." },
  { name: "Olivia", quote: "I tried to uninstall it. It suggested I reconsider." },
];

const Testimonies: React.FC = () => {
  const { t } = useTranslation("common");

  return (
    <section className="py-16">
      <h2 className="text-3xl font-bold text-center mb-12" id="testimonies">
        {t("testimonies")}
      </h2>

      <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 px-4 md:px-16">
        {testimonies.map((testimonial, idx) => (
          <Card key={idx} className="shadow-lg">
            <CardContent className="flex flex-col items-start gap-4 override">
              <p className="text-gray-700 override">
                {t(`testimonial.quote.${idx}`, testimonial.quote)}
              </p>
              <p className="font-semibold mt-2">
                {t(`testimonial.name.${idx}`, testimonial.name)}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default Testimonies;